import { Dispatch } from 'react'
import { getTranslations } from 'redux/reducers/translationsReducer'

export const getTranslationAction = (
  dispatch: Dispatch<{ type: string; payload: { resolve: () => void; reject: () => void } }>,
) =>
  new Promise<void>((resolve, reject) => {
    dispatch({ type: getTranslations.type, payload: { resolve, reject } })
  })
